import AutodeskViewer from './AutodeskViewer.component';

export default AutodeskViewer;
